module.exports = __webpack_public_path__ + "static/media/talent-feature-interview-offer.a9e36510.png";